function dealerChatService ($http, $q, $window, $document, $location, $sce, userDataService, listingService, pageStateService) {
    const PLACEMENT_ID = 1;
    const CARS_PROVIDER_ID = 297;
    const POPUP_OPTIONS = 'resizable=yes,toolbar=no,menubar=no,location=no,scrollbars=no,status=no,height=400,width=600';

    return {
        isDealerOnline,
        isActiveEngageEnabled,
        getListingData,
        fireChatPageStateEvent,
    };

    function isDealerOnline(customerId) {
        const url = $sce.trustAsResourceUrl('https://jsonp.contactatonce.com/PresencePostback.aspx');
        return $http.jsonp(url, {
            cache: true,
            params: {
                jsonpCallbackParam: 'callback',
                ProviderId: CARS_PROVIDER_ID,
                MerchantId: customerId,
                PlacementId: PLACEMENT_ID
            }
        }).then((response)=> {
            return response.data.presenceStatus === 'online';
        });
    }

    function isActiveEngageEnabled() {
        let chatAccount = $document[0].body.attributes['chat-account'];
        return !angular.isUndefined(chatAccount);
    }

    function getListingData() {
        return listingService.getListing().then(listingResponse => {
            let payload = {};
            let detailDto = listingResponse.listingDetailDto;
            payload.dealerInspireApi = detailDto.dealerInspireApi;
            payload.MerchantId = detailDto.customerId;
            payload.Year = detailDto.modelYear;
            payload.makeName = detailDto.makeName;
            payload.modelName = detailDto.modelName;
            payload.caId = detailDto.listingId;
            payload.vin = detailDto.vin;
            payload.price = detailDto.price;
            payload.stockNumber = detailDto.stockNumber;
            payload.stockType = detailDto.stockTypeCode;
            payload.cpoVehicle = detailDto.cpoVehicle;
            payload.bodystyleName = detailDto.bodystyleName;
            payload.dealerName = detailDto.dealerName;
            payload.privatePartyListing = detailDto.privatePartyListing;
            return payload;
        });
    }

    function fireChatPageStateEvent() {
        return getListingData().then((response) => {
            const lead = {
                category: 'chat',
                name: 'chat-seller',
                location: 'vdp',
                stockType: response.stockType,
                customerId: response.MerchantId,
                listingId: response.caId,
                cpo: response.cpoVehicle,
                make: response.makeName,
                model: response.modelName,
                bodyStyle: response.bodystyleName,
                year: response.Year,
                price: response.price,
                dealer: response.dealerName,
            };
            let pgName;
            if ( !response.privatePartyListing ){
                if (stockType === 'New') {
                    pgName = 'New Cars/Search/details-details-dealer';
                } else {
                    pgName = 'Used Cars/Search/details-details-dealer';
                }
            } else {
                pgName = 'Used Cars/Search/details-details-siy';
            }
            pageStateService.push('page.lead', lead, false);
            pageStateService.push('event', { eventName: 'lead', eventDetail: 'chat', linkName: 'chat-send-enter' }, true);
        });
    }
}

dealerChatService.$inject = [
    '$http',
    '$q',
    '$window',
    '$document',
    '$location',
    '$sce',
    'userDataService',
    'listingService',
    'pageStateService'
];

export default dealerChatService;
